import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { loadLocation } from '../../actions/location';
import { fetchTimeseries } from '../../actions/timeseries';
import { setWindow } from '../../actions/config';
import LocationSearch from '../../components/Search';
import PageHeader from '../../components/PageHeader';
import Leaderboard from '../../components/Leaderboard';
import Comparison from '../../components/Comparison';
import Disclaimer from '../../components/Disclaimer';
import NavBar from '../../components/NavBar';
import AppHeader from '../../components/AppHeader';
import Timeseries from '../../components/Timeseries';
import TimeSelector from '../../components/TimeSelector';
import NoticeWindow from '../../components/NoticeWindow';
import localize from '../../components/localize';
import './LocationResults.css';

const NoResults = localize('pages.scores.noresults')(({ i18n }) => (
	<NoticeWindow i18n={i18n} className='no-results' />
));

const LoadingError = localize('errors.loading')(({ i18n }) => (
  <NoticeWindow i18n={i18n} className='loading-error' />
));

class LocationResults extends Component {
	componentWillMount() {
		this.fetchLocation();

		window.scrollTo(0, 0);
	}

	componentDidUpdate() {
		this.fetchLocation();
	}

	fetchLocation() {
		if(this.props.match.params.location_id) {
			this.props.loadLocation(this.props.match.params.location_id, this.props.match.params.shard);
		}
	}

	render() {
		const { locationLoaded, locationError, location, timeWindow, setWindow, timeseries, fetchTimeseries } = this.props;

		return  <div>
							<AppHeader>
					      <NavBar />
					    </AppHeader>

					    { locationError && <LoadingError /> }

							{ !locationError && <LocationSearch currentLocation={locationLoaded && location.location} shard={this.props.match.params.shard} showLocation={true} /> }

							{ locationLoaded && location.isps.length === 0 &&  <NoResults /> }

							{ locationLoaded && location.isps.length > 0 &&
								<div>
									<PageHeader i18nPath="pages.scores.leaderboard" />
										<div>
											<TimeSelector timeWindow={timeWindow} setWindow={setWindow}/>
										</div>
									<div className="centered-content"><Leaderboard location={location} timeWindow={timeWindow} /></div>
								</div>
							}

            	{locationLoaded && location.isps.length > 1 &&
                <div className="centered-content">
                  <PageHeader i18nPath="pages.scores.compare" />
                  <Comparison location={location.location} isps={location.isps} timeseries={timeseries} fetchTimeseries={fetchTimeseries} shard={this.props.match.params.shard} />

                </div>}
							{locationLoaded && location.isps.length === 1 &&
                <div className="centered-content">
                  <div className="single-timeseries">
                    <Timeseries dataA={location.isps[0]} dataB={{}} compareKey="connection_score" single={true} location={location.location} timeseries={timeseries} fetchTimeseries={fetchTimeseries} shard={this.props.match.params.shard} />
                  </div>
                </div>}
								<div className="disclaimer-footer">
									<Disclaimer />
								</div>
							</div>;
	}
}

export default compose(localize(), connect((state, ownProps) => {
	const location_id = ownProps.match.params.location_id;
	return {
		locationLoaded: state.locations[location_id] && !state.locations[location_id].isLoading && !state.locations[location_id].isError,
		locationError: state.locations[location_id] && state.locations[location_id].isError,
		location: state.locations[location_id],
		timeWindow: state.config.timeWindow,
		timeseries: state.timeseries,
	};
}, dispatch => {
	return {
		loadLocation: (location_id, shard) => dispatch(loadLocation(location_id, shard)),
		setWindow: (timeWindow) => dispatch(setWindow(timeWindow)),
		fetchTimeseries: (locationId, isp, shard) => dispatch(fetchTimeseries(locationId, isp, shard)),
	}
}))(LocationResults);



// WEBPACK FOOTER //
// ./src/pages/LocationResults/index.js